import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Microscope = function Microscope(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 22h9M11 6.252A8 8 0 0 1 13 6c4.4183 0 8 3.5817 8 8 0 3.3574-2.0682 6.2317-5 7.4185M5.5 13h4c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C12 14.803 12 15.0353 12 15.5s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C10.197 18 9.9647 18 9.5 18h-4c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C3 16.197 3 15.9647 3 15.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C4.803 13 5.0353 13 5.5 13M4 5.5V13h7V5.5C11 3.567 9.433 2 7.5 2S4 3.567 4 5.5"
    })
  }));
};
export default Microscope;